//<script type="text/javascript">
    // Instructions: please embed this snippet directly into every page in your website template.
    // For optimal performance, this must be embedded directly into the template, not referenced
    // as an external file.

    // ForeSee Staging Embed Script v2.01
    // DO NOT MODIFY BELOW THIS LINE *****************************************
    ; (function (g) {
        var d = document, am = d.createElement('script'), h = d.head || d.getElementsByTagName("head")[0], fsr = 'fsReady',
            aex = {
                "src": "//eex-gateway.fr011.ttecfed.com/sites/usajobs-gov/staging/gateway.min.js",
                "type": "text/javascript",
                "async": "true",
                "data-vendor": "fs",
                "data-role": "gateway"
            };
        for (var attr in aex) { am.setAttribute(attr, aex[attr]); } h.appendChild(am); g[fsr] || (g[fsr] = function () { var aT = '__' + fsr + '_stk__'; g[aT] = g[aT] || []; g[aT].push(arguments); });
    })(window);
// DO NOT MODIFY ABOVE THIS LINE *****************************************
//</script>
